'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validAlignSelfProps = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  width: 100%;\n  flex: 0 0 auto;\n  ', '}\n'], ['\n  box-sizing: border-box;\n  width: 100%;\n  flex: 0 0 auto;\n  ', '}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _responsiveProps = require('responsive-props');

var _responsiveProps2 = _interopRequireDefault(_responsiveProps);

var _propTypes2 = require('./propTypes');

var propTypes = _interopRequireWildcard(_propTypes2);

var _mixins = require('./utils/mixins');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // eslint-disable-line
// import getstyledFlexboxGrid from './HOC/getstyledFlexboxGrid';


var StyledColumn = _styledComponents2.default.div(_templateObject, function (_ref) {
  var responsiveProps = _ref.responsiveProps;
  return responsiveProps;
});

var displayName = 'Column';

var Column = function Column(props) {
  var children = props.children,
      theme = props.theme,
      fixed = props.fixed;
  var styledFlexboxGrid = theme.styledFlexboxGrid;
  var getColumnWidth = styledFlexboxGrid.getColumnWidth,
      getGutterWidth = styledFlexboxGrid.getGutterWidth; // Register methods to be used for responsive props

  var ColumnResponsiveProps = (0, _responsiveProps2.default)(StyledColumn, {
    align: _mixins.align,
    order: _mixins.order,
    hidden: _mixins.hidden,
    position: _mixins.position,
    gutterless: _mixins.gutterless,
    grow: _mixins.grow,
    shrink: _mixins.shrink,
    gutter: function gutter(args) {
      return (0, _mixins.gutter)(getGutterWidth(args));
    },
    span: function span(args) {
      return (0, _mixins.span)(getColumnWidth(args, fixed), fixed);
    },
    offset: function offset(args) {
      return (0, _mixins.offset)(getColumnWidth(args));
    },
    background: function background(bg) {
      return function () {
        return 'background: ' + bg + ';';
      };
    }
  });
  return _react2.default.createElement(ColumnResponsiveProps, {
    align: props.align,
    order: props.order,
    grow: props.grow,
    shrink: props.shrink,
    verticalAlign: props.verticalAlign,
    span: props.span,
    offset: props.offset,
    gutterless: props.gutterless,
    responsiveProps: props.responsiveProps,
    hidden: props.hidden,
    position: props.position,
    debug: props.debug,
    gutter: styledFlexboxGrid.gutter,
    breakpoints: styledFlexboxGrid.breakpoints
  }, children);
};

var validAlignSelfProps = exports.validAlignSelfProps = Object.keys(_mixins.alignSelfValues);
var columnPropTypes = {
  children: _propTypes.node,
  debug: _propTypes.bool,
  fixed: _propTypes.bool,
  grow: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  shrink: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  order: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  hidden: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.bool), _propTypes.bool]),
  gutterless: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.bool), _propTypes.bool]),
  align: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(validAlignSelfProps), (0, _propTypes.objectOf)((0, _propTypes.oneOf)(validAlignSelfProps))]),
  span: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  offset: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number])
};
Column.propTypes = _extends({
  styledFlexboxGrid: (0, _propTypes.shape)(propTypes.styledFlexboxGrid),
  theme: (0, _propTypes.shape)({
    styledFlexboxGrid: (0, _propTypes.shape)(propTypes.styledFlexboxGrid)
  })
}, columnPropTypes);
Column.defaultProps = {
  // fixed: false,
  // hidden: false,
  // debug: false,
  // auto: false,
  theme: (0, _propTypes.shape)({}),
  styledFlexboxGrid: undefined
};
var GridColumn = (0, _styledComponents.withTheme)(Column);
GridColumn.displayName = displayName;
GridColumn.propTypes = _extends({}, columnPropTypes);
exports.default = GridColumn;